import React from 'react';
import SearchBar from './SearchBar';
import FeaturedListings from './FeaturedListings';
import kitchenHero from '../images/kitchen-hero.jpg';

const DirectoryHome = () => {
  const stats = [
    {
      number: '500+',
      label: 'Service Providers',
      description: 'Trusted repair companies',
    },
    {
      number: '24/7',
      label: 'Emergency Service',
      description: 'Available anytime',
    },
    {
      number: '50+',
      label: 'Cities Covered',
      description: 'And growing daily',
    },
  ];

  return (
    <main>
      <section
        className="hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)), url(${kitchenHero})`,
          backgroundAttachment: 'fixed',
        }}
      >
        <div className="hero-content">
          <h1>
            <span className="text-muted">EXPERT COMMERCIAL</span>
            <br />
            KITCHEN <span className="text-accent">REPAIR SERVICES</span>
          </h1>
          <p>
            Connect with trusted repair companies for your restaurant and food service equipment
          </p>
          <SearchBar />
          <div className="stats-container">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
                <div className="stat-description">{stat.description}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <FeaturedListings />
    </main>
  );
};

export default DirectoryHome;
